<template>
    <div class="legal-warning">
        <TransitionFade>
            <div v-if="isLegalWarningVisible" @click="handleClickClose" class="legal-warning__overlay"></div>
        </TransitionFade>
        <Transition name="slide-up">
            <div v-if="isLegalWarningVisible" class="legal-warning__popup-container">
                <div class="legal-warning__popup">
                    <WebpImage
                        class="legal-warning__picture"
                        css-class="legal-warning__img"
                        src="/frontend/web/img/homepage/legal-warning/18plus.svg"
                        alt="18+"
                    />
                    <p class="legal-warning__text">
                        Zákaz účasti na hazardní hře osobám mladších 18 let. | Účast na hazardní hře může být škodlivá.
                    </p>
                    <button class="legal-warning__close" @click="handleClickClose">
                        <DsIcon class="legal-warning__close-icon" name="close" :width="12" :height="12" />
                    </button>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { LegalWarningAnalytics } from "@/shared/utils/analytics/analytics-legal-warning";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { useLocalStorage, useSessionStorage } from "@sazka/utils/use-storage";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import { usePopupsSequence } from "@/shared/components/master-page/use-popups-sequence";

const POPUP_CLOSED_KEY = "legalWarningClosed";
const POPUP_TIME_VISIBLE = 2800;

const { getItem, setItem } = useSessionStorage();
const { isLegalWarningVisible, isLegalWarningClosed } = usePopupsSequence();

const closeLegalWarningModal = () => {
    isLegalWarningClosed.value = true;
    isLegalWarningVisible.value = false;
    setItem(POPUP_CLOSED_KEY, "true", "essential");
};

const openLegalWarningModal = () => {
    isLegalWarningVisible.value = true;
};

const handleClickClose = () => {
    closeLegalWarningModal();
    LegalWarningAnalytics.closePopupScreen();
};

watch(isLegalWarningVisible, (newValue) => {
    if (newValue) {
        setTimeout(() => {
            closeLegalWarningModal();
        }, POPUP_TIME_VISIBLE);
    }
});

const isProd = environment.env === "Production";
const blockPopup = ref(false);
if (!isProd) {
    const blockItem = useLocalStorage().getItem("devBlockLegalWarning");
    blockPopup.value = blockItem === "true";
}

const keyDownEventHandler = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeLegalWarningModal();
    }
};

onMounted(() => {
    if (blockPopup.value) return;

    const modalClosed = getItem(POPUP_CLOSED_KEY);
    if (modalClosed === "true") return;

    openLegalWarningModal();
    LegalWarningAnalytics.openPopupScreen();
    document.addEventListener("keydown", keyDownEventHandler, { once: true });
});
</script>
